import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-clip",
  "use": "foquz-icon-clip-usage",
  "viewBox": "0 0 19 20",
  "content": "<symbol viewBox=\"0 0 19 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-clip\"><path d=\"M17.976 9.438L9.95 17.464a5.243 5.243 0 01-7.414-7.414l8.026-8.026a3.495 3.495 0 114.943 4.943L7.47 14.993a1.747 1.747 0 11-2.472-2.472l7.415-7.406\" stroke=\"#73808D\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol